







import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

interface Request {
    beginDate: string;
    endDate: string;
}

@Component({ components: { } })
export default class Date extends Vue {
    @Prop() public request!: Request;

    public static getNeededFields(): string[] {
        return [
            "request.beginDate",
            "request.endDate",
            "request.children.beginDate",
            "request.children.endDate",
        ];
    }
}
